import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BaseComponent } from '../../shared/base.component';
import { AddDroneState } from '../../shared/state-interface';
import { SiteHeaderComponent } from '../../site-header/site-header.component';
import { DroneModel } from '../shared/drone-model.model';
import { DroneComponent } from "../shared/drone.component";
import { DroneService } from '../shared/drone.service';

@Component({
    selector: 'app-add-drone',
    standalone: true,
    imports: [
    ReactiveFormsModule,
    MatButtonModule,
    SiteHeaderComponent,
    DroneComponent
],
    templateUrl: './add-drone.component.html',
    styleUrl: './add-drone.component.css'
})
export class AddDroneComponent extends BaseComponent implements AfterViewInit {

    @ViewChild(DroneComponent) droneComponent!:DroneComponent;

    private droneService: DroneService = inject(DroneService);

    private static _addingDrone = "Adding Drone";
    private static _addingDroneError = `${AddDroneComponent._addingDrone} error:`;

    public ngAfterViewInit() {
        const state: AddDroneState | undefined = this.stateManager.addDroneState;
        
        if (state !== undefined) {
            this.droneComponent.restoreState(state.droneComponentState);
            super.restoreState(state.baseComponentState);
        } else {
            this.droneComponent.init();
        }
    }

    public ngOnDestroy() {
        const state: AddDroneState = {} as AddDroneState;
        state.droneComponentState = this.droneComponent.getState();
        state.baseComponentState = super.getState();
        this.stateManager.addDroneState = state;
    }

    protected cancel() {
        this.router.navigate(["/view-drones"], { state: { restore: true } });
    }

    protected async save() {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const model: DroneModel = this.droneComponent.droneModelsComponent.droneModelCtl.value;

            const observable = await this.droneService.addDrone(await getIdToken(currentUser),
                model.type, this.droneComponent.manufactureDateCtl.value);
            this.message = "";
            super.showSnackBar(`${AddDroneComponent._addingDrone}...`, -1);

            observable.subscribe(response => {
                try {
                    const json = JSON.parse(JSON.stringify(response));
                    if (json["add-drone"] == "success") {
                        const queryParam = `Serial Number '${json["serial-number"]}' generated.`;
                        this.router.navigate(["/view-drones"], { queryParams: {"overrideSnackBar": queryParam}, state: { refresh: true } });
                    } else {
                        throw new Error(json["message"]);
                    }
                } catch (error) {
                    const message = `${AddDroneComponent._addingDroneError} ${(<Error>error).message}`;
                    this.message = message;
                    super.dismissSnackBar();
                }
            })
        } else {
            const message = `${AddDroneComponent._addingDroneError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }
}
